import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import { IModalWindow } from '@hooks/useModalWindow';
import { Divider } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import HistoryIcon from '@material-ui/icons/History';
import React from 'react';

export type ExcedenteMenuProps = {
    menu: IMenu
    cancelarModal: IModalWindow
    atividadeModal: IModalWindow
}

export function ExcedenteMenu ({ menu, cancelarModal, atividadeModal }: ExcedenteMenuProps) {
    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={1} 
                onClick={menu.handleItemClick(cancelarModal.open)}
                text="Cancelar Excedente"
                icon={<CancelIcon />}
            />

            <Divider />

            <RowMenuItem 
                key={2} 
                onClick={menu.handleItemClick(atividadeModal.open)}
                text="Atividades"
                icon={<HistoryIcon />}
            />
        </RowMenu>
    )
}